module.exports = window.mapPowerUpId



// WEBPACK FOOTER //
// ./app/scripts/data/map-power-up-id.coffee